import appVersion from './app_version'

// Difference between 1 and the greatest float > 1
if (Number.EPSILON === undefined) Number.EPSILON = Math.pow(2, -52)

// app version must be greater than the listed version otherwise
// can() should return false.
const ACTION_TO_VERSION_LIST = {
  chat: 44.1,
  postMessage: 19.0,
  postNatively: 30.0,
  showAddPost: 19.0,
  showAlertSheet: 19.0,
  showChildPanel: 18.0,
  signalStatusWithLocation: 19.0,
  useNativeHeader: 59.1,
  useNativeCommentsPanel: 104.9,
  useNativeMapLocationPicker: 106.0,
}

export default action => {
  if (appVersion != null) {
    // floating point comparison
    return appVersion - ACTION_TO_VERSION_LIST[action] > Number.EPSILON
  }
  return false
}
